// OpenGraph Meta Tags Utility
export const updateOpenGraphTags = (ogData, defaultOgImage = null) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  
  const updateOrCreateOGMeta = (property, content) => {
    if (!content) return;
    
    let ogMeta = document.querySelector(`meta[property="${property}"]`);
    if (ogMeta) {
      ogMeta.setAttribute('content', content);
    } else {
      ogMeta = document.createElement('meta');
      ogMeta.setAttribute('property', property);
      ogMeta.setAttribute('content', content);
      document.head.appendChild(ogMeta);
    }
  };
  
  updateOrCreateOGMeta('og:title', ogData.title);
  updateOrCreateOGMeta('og:description', ogData.description);
  updateOrCreateOGMeta('og:type', ogData.type || 'website');
  updateOrCreateOGMeta('og:url', ogData.url || window.location.href);
  updateOrCreateOGMeta('og:site_name', 'FogPortál.hu');
  
  let imageUrl = null;
  if (ogData.image) {
    imageUrl = ogData.image.startsWith('http') ? ogData.image : `${backendUrl}${ogData.image}`;
  } else if (defaultOgImage) {
    imageUrl = defaultOgImage.startsWith('http') ? defaultOgImage : `${backendUrl}${defaultOgImage}`;
  }
  
  if (imageUrl) {
    updateOrCreateOGMeta('og:image', imageUrl);
    updateOrCreateOGMeta('og:image:alt', ogData.imageAlt || ogData.title || 'FogPortál.hu kép');
  }
  
  updateOrCreateOGMeta('og:locale', 'hu_HU');
  
  updateOrCreateOGMeta('twitter:card', 'summary_large_image');
  updateOrCreateOGMeta('twitter:title', ogData.title);
  updateOrCreateOGMeta('twitter:description', ogData.description);
  if (imageUrl) {
    updateOrCreateOGMeta('twitter:image', imageUrl);
  }
};
